import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { supabase } from '../lib/supabase'
import toast from 'react-hot-toast'

const TRIBE_STYLES = `
  /* HERO */
  .tribe-hero { background:linear-gradient(135deg,#0D1B3E 0%,#1A3A5E 60%,#3A2A6E 100%); color:#fff; border-radius:16px; padding:32px 28px; margin-bottom:20px; position:relative; overflow:hidden; }
  .tribe-hero::before { content:''; position:absolute; top:-50%; right:-10%; width:400px; height:400px; background:radial-gradient(circle,rgba(168,124,232,0.18),transparent 70%); pointer-events:none; }
  .tribe-hero-title { font-family:'Cormorant Garamond',serif; font-size:32px; font-weight:600; color:#C9A84C; margin:0 0 8px; letter-spacing:0.02em; position:relative; }
  .tribe-hero-sub { font-size:13px; color:rgba(255,255,255,0.75); margin:0; line-height:1.6; position:relative; max-width:640px; }
  .tribe-hero-badge { display:inline-block; background:rgba(168,124,232,0.2); border:1px solid rgba(168,124,232,0.4); color:#D4B5FF; font-size:10px; font-weight:700; padding:3px 10px; border-radius:12px; letter-spacing:0.08em; margin-bottom:8px; position:relative; }

  /* TABS */
  .tribe-tabs { display:flex; gap:0; border-bottom:2px solid #E8E6DF; margin-bottom:20px; flex-wrap:wrap; }
  .tribe-tab { padding:10px 16px; font-size:12px; font-weight:600; cursor:pointer; border:none; background:none; color:#7A7870; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.15s; font-family:inherit; white-space:nowrap; display:flex; align-items:center; gap:6px; }
  .tribe-tab:hover { color:#0D1B3E; }
  .tribe-tab.active { color:#0D1B3E; border-bottom-color:#A87CE8; }
  .tribe-tab-badge { background:#A87CE8; color:#fff; font-size:9px; font-weight:700; padding:1px 6px; border-radius:10px; }

  /* SECTIONS */
  .tribe-section { background:#fff; border:1px solid #E8E6DF; border-radius:14px; overflow:hidden; margin-bottom:16px; }
  .tribe-section-header { padding:14px 20px; background:linear-gradient(135deg,#F8F7F4,#F0EEE8); border-bottom:1px solid #E8E6DF; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px; }
  .tribe-section-title { font-size:13px; font-weight:600; color:#0D1B3E; letter-spacing:0.04em; }

  /* COMPOSE */
  .tribe-compose { padding:18px 20px; border-bottom:1px solid #F0EEE8; }
  .tribe-compose-input { width:100%; padding:12px 14px; border:1.5px solid #E0D9CC; border-radius:10px; font-size:13px; font-family:inherit; resize:vertical; min-height:60px; box-sizing:border-box; line-height:1.6; }
  .tribe-compose-input:focus { outline:none; border-color:#A87CE8; }
  .tribe-compose-actions { display:flex; justify-content:space-between; align-items:center; margin-top:10px; gap:10px; flex-wrap:wrap; }
  .tribe-compose-hint { font-size:11px; color:#B8B5AB; }

  /* POST CARDS */
  .tribe-post { padding:18px 20px; border-bottom:1px solid #F0EEE8; transition:background 0.15s; }
  .tribe-post:last-child { border-bottom:none; }
  .tribe-post:hover { background:#FAFAF8; }
  .tribe-post.pinned { background:linear-gradient(90deg,#FFFBF0,#fff); border-left:3px solid #C9A84C; }
  .tribe-post.ceo { background:linear-gradient(90deg,#F8F4FF,#fff); border-left:3px solid #A87CE8; }
  .tribe-post-head { display:flex; align-items:flex-start; gap:12px; }
  .tribe-avatar { width:42px; height:42px; border-radius:50%; background:linear-gradient(135deg,#0D1B3E,#1A3A5E); color:#C9A84C; display:flex; align-items:center; justify-content:center; font-size:15px; font-weight:600; flex-shrink:0; overflow:hidden; }
  .tribe-avatar.ceo { background:linear-gradient(135deg,#A87CE8,#7C4FCE); color:#fff; }
  .tribe-avatar img { width:100%; height:100%; object-fit:cover; display:block; }
  .tribe-post-meta { flex:1; min-width:0; }
  .tribe-post-author { font-size:13px; font-weight:600; color:#0D1B3E; display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
  .tribe-ceo-tag { background:#A87CE8; color:#fff; font-size:9px; font-weight:700; padding:1px 7px; border-radius:10px; letter-spacing:0.05em; }
  .tribe-pin-tag { background:#C9A84C; color:#0D1B3E; font-size:9px; font-weight:700; padding:1px 7px; border-radius:10px; letter-spacing:0.05em; }
  .tribe-new-tag { background:#C9A84C; color:#0D1B3E; font-size:9px; font-weight:800; padding:2px 8px; border-radius:10px; letter-spacing:0.05em; display:inline-block; }
  .tribe-mention { background:#F3E8FF; color:#6B2FA0; font-weight:700; padding:1px 7px; border-radius:8px; }
  .tribe-mention-tag { background:#6B2FA0; color:#fff; font-size:9px; font-weight:800; padding:2px 8px; border-radius:10px; letter-spacing:0.05em; display:inline-block; }
  .tribe-mention-banner { background:#F3E8FF; border:1px solid #DFC5F7; border-radius:10px; padding:10px 14px; font-size:13px; color:#6B2FA0; font-weight:700; margin-bottom:14px; }
  .tribe-mention-menu { position:absolute; top:100%; left:0; margin-top:4px; width:250px; max-height:220px; overflow-y:auto; background:#fff; border:1px solid #E8E6DF; border-radius:10px; box-shadow:0 6px 18px rgba(13,27,62,.12); z-index:50; }
  .tribe-mention-item { display:flex; align-items:center; gap:8px; padding:8px 12px; font-size:13px; color:#2C2C2C; cursor:pointer; }
  .tribe-mention-item:hover { background:#F8F0FF; color:#6B2FA0; font-weight:600; }
  .tribe-mention-ini { width:24px; height:24px; border-radius:50%; background:#0D1B3E; color:#C9A84C; font-size:10px; font-weight:700; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0; }
  .tribe-post.fresh { background:#FDF9EE; box-shadow: inset 3px 0 0 #C9A84C; }
  .tribe-post-time { font-size:11px; color:#B8B5AB; margin-top:2px; }
  .tribe-post-body { margin-top:10px; font-size:14px; color:#1A1A1A; line-height:1.7; white-space:pre-line; word-wrap:break-word; }
  .tribe-post-actions { margin-top:12px; display:flex; gap:8px; align-items:center; }
  .tribe-action-btn { background:none; border:1px solid #E8E6DF; border-radius:20px; padding:6px 14px; font-size:11px; font-weight:600; color:#7A7870; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:5px; transition:all 0.15s; }
  .tribe-action-btn:hover { border-color:#A87CE8; color:#A87CE8; }
  .tribe-action-btn.liked { background:#FCE4EC; border-color:#E91E63; color:#E91E63; }

  /* COMMENTS */
  .tribe-comments { margin-top:12px; padding-top:12px; border-top:1px solid #F0EEE8; }
  .tribe-comment { display:flex; gap:10px; padding:8px 0; }
  .tribe-comment-avatar { width:28px; height:28px; border-radius:50%; background:#E8E6DF; color:#7A7870; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; flex-shrink:0; overflow:hidden; }
  .tribe-comment-avatar img { width:100%; height:100%; object-fit:cover; display:block; }
  .tribe-comment-body { flex:1; background:#F8F7F4; border-radius:10px; padding:8px 12px; }
  .tribe-comment-author { font-size:11px; font-weight:600; color:#0D1B3E; }
  .tribe-comment-time { font-size:9px; color:#B8B5AB; margin-left:6px; }
  .tribe-comment-text { font-size:12px; color:#4A4840; margin-top:2px; line-height:1.5; word-wrap:break-word; }
  .tribe-comment-input-wrap { display:flex; gap:8px; margin-top:8px; align-items:flex-end; }
  .tribe-comment-input { flex:1; padding:8px 12px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:12px; font-family:inherit; box-sizing:border-box; }
  .tribe-comment-input:focus { outline:none; border-color:#A87CE8; }

  /* BUTTONS */
  .tribe-btn-primary { padding:10px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#A87CE8,#7C4FCE); color:#fff; cursor:pointer; font-size:13px; font-weight:600; font-family:inherit; transition:all 0.15s; }
  .tribe-btn-primary:hover:not(:disabled) { background:linear-gradient(135deg,#7C4FCE,#A87CE8); }
  .tribe-btn-primary:disabled { opacity:0.5; cursor:not-allowed; }
  .tribe-btn-outline { padding:8px 16px; border-radius:8px; border:1.5px solid #A87CE8; background:#fff; color:#A87CE8; cursor:pointer; font-size:12px; font-weight:600; font-family:inherit; }
  .tribe-btn-outline:hover { background:#F8F4FF; }

  /* BIRTHDAY BANNER */
  .tribe-bday-banner { background:linear-gradient(135deg,#FDF6E3,#FCE9A8); border:1px solid #C9A84C; border-radius:14px; padding:16px 20px; margin-bottom:16px; display:flex; align-items:center; gap:14px; flex-wrap:wrap; }
  .tribe-bday-icon { font-size:32px; line-height:1; flex-shrink:0; }
  .tribe-bday-text { flex:1; min-width:140px; }
  .tribe-bday-title { font-family:'Cormorant Garamond',serif; font-size:18px; font-weight:600; color:#8A5C00; margin-bottom:4px; }
  .tribe-bday-names { font-size:13px; color:#9A6800; line-height:1.5; }

  /* DIRECTORY */
  .tribe-dir-search { width:100%; padding:10px 14px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; box-sizing:border-box; margin-bottom:10px; }
  .tribe-dir-search:focus { outline:none; border-color:#A87CE8; }
  .tribe-dir-filters { display:flex; gap:8px; padding:0 0 14px; flex-wrap:wrap; }
  .tribe-dir-filter { padding:5px 14px; border-radius:20px; font-size:11px; font-weight:600; border:1.5px solid #E0D9CC; background:#fff; color:#7A7870; cursor:pointer; font-family:inherit; }
  .tribe-dir-filter.active { background:#A87CE8; color:#fff; border-color:#A87CE8; }
  .tribe-dir-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:12px; padding:0 20px 20px; }
  .tribe-dir-card { border:1px solid #E8E6DF; border-radius:12px; padding:16px; background:#fff; transition:all 0.2s; text-align:center; }
  .tribe-dir-card:hover { border-color:#A87CE8; box-shadow:0 4px 14px rgba(168,124,232,0.15); transform:translateY(-2px); }
  .tribe-dir-avatar { width:64px; height:64px; border-radius:50%; background:linear-gradient(135deg,#0D1B3E,#1A3A5E); color:#C9A84C; display:flex; align-items:center; justify-content:center; font-size:24px; font-weight:600; margin:0 auto 10px; overflow:hidden; }
  .tribe-dir-avatar img { width:100%; height:100%; object-fit:cover; display:block; }
  .tribe-dir-name { font-family:'Cormorant Garamond',serif; font-size:16px; font-weight:600; color:#0D1B3E; margin-bottom:4px; }
  .tribe-dir-state { font-size:11px; color:#7A7870; margin-bottom:8px; }
  .tribe-dir-badges { display:flex; gap:4px; justify-content:center; flex-wrap:wrap; }
  .tribe-dir-badge { font-size:9px; font-weight:700; padding:2px 7px; border-radius:10px; letter-spacing:0.04em; }
  .tribe-dir-badge.vetted { background:#0D1B3E; color:#C9A84C; }
  .tribe-dir-badge.elite { background:#2D7A4F; color:#fff; }
  .tribe-dir-badge.founder { background:#A87CE8; color:#fff; }
  .tribe-dir-badge.ron { background:#4B5EAA; color:#fff; }

  /* COMING SOON */
  .tribe-cs-intro { padding:18px 20px; border-bottom:1px solid #F0EEE8; background:linear-gradient(135deg,#F8F4FF,#fff); }
  .tribe-cs-intro-title { font-family:'Cormorant Garamond',serif; font-size:20px; font-weight:600; color:#0D1B3E; margin-bottom:6px; }
  .tribe-cs-intro-text { font-size:13px; color:#7A7870; line-height:1.6; }
  .tribe-cs-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); gap:14px; padding:20px; }
  .tribe-cs-card { border:1.5px dashed #C0A0F0; border-radius:14px; padding:18px; background:linear-gradient(135deg,#FAFAFF,#fff); position:relative; transition:all 0.2s; }
  .tribe-cs-card:hover { border-color:#A87CE8; transform:translateY(-2px); box-shadow:0 4px 12px rgba(168,124,232,0.12); }
  .tribe-cs-icon { font-size:32px; margin-bottom:10px; }
  .tribe-cs-title { font-family:'Cormorant Garamond',serif; font-size:18px; font-weight:600; color:#0D1B3E; margin-bottom:6px; }
  .tribe-cs-desc { font-size:12px; color:#7A7870; line-height:1.6; margin-bottom:14px; min-height:48px; }
  .tribe-cs-actions { display:flex; align-items:center; justify-content:space-between; gap:8px; flex-wrap:wrap; }
  .tribe-cs-status { font-size:9px; font-weight:700; padding:3px 9px; border-radius:10px; letter-spacing:0.06em; }
  .tribe-cs-status.planned { background:#EEF2FF; color:#4B5EAA; }
  .tribe-cs-status.researching { background:#FDF6E3; color:#8A5C00; }
  .tribe-cs-status.building { background:#EAF5EE; color:#2D7A4F; }
  .tribe-cs-status.shipped { background:#A87CE8; color:#fff; }
  .tribe-cs-vote { background:#A87CE8; color:#fff; border:none; border-radius:20px; padding:5px 14px; font-size:11px; font-weight:600; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:5px; transition:all 0.15s; }
  .tribe-cs-vote:hover:not(:disabled) { background:#7C4FCE; }
  .tribe-cs-vote.voted { background:#F8F4FF; color:#7C4FCE; border:1px solid #A87CE8; }
  .tribe-cs-vote:disabled { cursor:not-allowed; opacity:0.7; }

  /* PAIN POINTS */
  .tribe-pp-intro { padding:18px 20px; background:linear-gradient(135deg,#FFF8F8,#fff); border-bottom:1px solid #F0EEE8; }
  .tribe-pp-intro-title { font-family:'Cormorant Garamond',serif; font-size:20px; font-weight:600; color:#0D1B3E; margin-bottom:6px; }
  .tribe-pp-intro-text { font-size:13px; color:#7A7870; line-height:1.6; }
  .tribe-pp-form { padding:20px; }
  .tribe-pp-label { display:block; font-size:11px; font-weight:600; color:#7A7870; letter-spacing:0.06em; margin-bottom:6px; margin-top:14px; }
  .tribe-pp-label:first-child { margin-top:0; }
  .tribe-pp-input, .tribe-pp-textarea, .tribe-pp-select { width:100%; padding:10px 14px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; box-sizing:border-box; line-height:1.6; background:#fff; }
  .tribe-pp-input:focus, .tribe-pp-textarea:focus, .tribe-pp-select:focus { outline:none; border-color:#A87CE8; }
  .tribe-pp-textarea { resize:vertical; min-height:90px; }
  .tribe-pp-check { display:flex; align-items:center; gap:8px; margin-top:14px; cursor:pointer; font-size:13px; color:#4A4840; }
  .tribe-pp-success { background:linear-gradient(135deg,#EAF5EE,#F0FAF4); border:1px solid #2D7A4F; border-radius:14px; padding:24px; text-align:center; margin:20px; }
  .tribe-pp-success-icon { font-size:48px; margin-bottom:10px; }
  .tribe-pp-success-title { font-family:'Cormorant Garamond',serif; font-size:22px; font-weight:600; color:#2D7A4F; margin-bottom:8px; }
  .tribe-pp-success-text { font-size:13px; color:#4A6850; line-height:1.6; }

  /* EMPTY */
  .tribe-empty { text-align:center; padding:50px 20px; color:#B8B5AB; }
  .tribe-empty-icon { font-size:48px; margin-bottom:12px; opacity:0.6; }
  .tribe-empty-text { font-size:13px; color:#7A7870; max-width:400px; margin:0 auto 16px; line-height:1.6; }

  /* LOADER */
  .tribe-loading { text-align:center; padding:60px 20px; color:#B8B5AB; font-size:13px; }
`

// ─── HELPERS ──────────────────────────────────────────────────────
function timeAgo(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  const d = new Date(date)
  return d.toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })
    + ' · ' + d.toLocaleTimeString('en-US', { hour:'2-digit', minute:'2-digit' })
}

function getInitials(name) {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?'
}

// ── 💜 @MENTIONS ─────────────────────────────────────────────────
function escRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }

// Renders text with @Full Name (and @everyone) as purple mention pills.
function MentionText({ text, names }) {
  const content = String(text || '')
  if (!content.includes('@')) return <>{content}</>
  const sorted = (names || []).slice().sort((a, b) => b.length - a.length)
  const pattern = ['everyone', ...sorted.map(escRegex)].join('|')
  let re
  try { re = new RegExp(`@(${pattern})`, 'gi') } catch (e) { return <>{content}</> }
  const parts = []
  let last = 0, m
  while ((m = re.exec(content)) !== null) {
    if (m.index > last) parts.push(content.slice(last, m.index))
    parts.push(<span key={`m${m.index}`} className="tribe-mention">@{m[1]}</span>)
    last = m.index + m[0].length
  }
  if (last < content.length) parts.push(content.slice(last))
  return <>{parts}</>
}

// Textarea/input with an @ member picker. Type @ to open, keep typing to filter, click to insert.
function MentionInput({ as = 'textarea', value, onChange, members, extraOptions = [], onKeyDown, className, placeholder }) {
  const ref = useRef(null)
  const [query, setQuery] = useState(null) // { start, text } | null

  function updateQuery(el) {
    try {
      const caret = el.selectionStart
      const upto = (el.value || '').slice(0, caret)
      const at = upto.lastIndexOf('@')
      if (at === -1) { setQuery(null); return }
      if (at > 0 && !/[\s(]/.test(upto[at - 1])) { setQuery(null); return }
      const q = upto.slice(at + 1)
      if (q.length > 30 || q.includes('\n')) { setQuery(null); return }
      setQuery({ start: at, text: q })
    } catch (e) { setQuery(null) }
  }

  const matches = query === null ? [] : [
    ...extraOptions.filter(o => o.full_name.toLowerCase().startsWith(query.text.toLowerCase())),
    ...(members || []).filter(mm => (mm.full_name || '').toLowerCase().startsWith(query.text.toLowerCase())),
  ].slice(0, 6)

  function pick(name) {
    const el = ref.current
    const caret = el ? el.selectionStart : String(value).length
    const next = String(value).slice(0, query.start) + '@' + name + ' ' + String(value).slice(caret)
    onChange(next)
    setQuery(null)
    setTimeout(() => {
      try { el.focus(); const pos = query.start + name.length + 2; el.setSelectionRange(pos, pos) } catch (e) { /* ignore */ }
    }, 0)
  }

  const Tag = as
  return (
    <div style={{ position: 'relative', flex: as === 'input' ? 1 : undefined }}>
      <Tag ref={ref} className={className} placeholder={placeholder} value={value}
        onChange={e => { onChange(e.target.value); updateQuery(e.target) }}
        onKeyUp={e => updateQuery(e.target)}
        onClick={e => updateQuery(e.target)}
        onBlur={() => setTimeout(() => setQuery(null), 150)}
        onKeyDown={onKeyDown}
      />
      {query !== null && matches.length > 0 && (
        <div className="tribe-mention-menu">
          {matches.map(mm => (
            <div key={mm.id || mm.full_name} className="tribe-mention-item"
              onMouseDown={e => { e.preventDefault(); pick(mm.full_name) }}>
              {mm.icon
                ? <span style={{ fontSize: 14 }}>{mm.icon}</span>
                : <span className="tribe-mention-ini">{getInitials(mm.full_name)}</span>}
              <span>{mm.full_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function extractMentionIds(text, members, selfId) {
  const found = new Set()
  const content = String(text || '').toLowerCase()
  ;(members || []).forEach(mm => {
    if (mm.id && mm.id !== selfId && mm.full_name && content.includes('@' + mm.full_name.toLowerCase())) found.add(mm.id)
  })
  return [...found]
}

async function saveMentions({ postId = null, commentId = null, text, members, authorId }) {
  try {
    const ids = extractMentionIds(text, members, authorId)
    if (ids.length === 0) return
    await supabase.from('tribe_mentions').insert(ids.map(uid => ({
      post_id: postId, comment_id: commentId, mentioned_user_id: uid, author_id: authorId,
    })))
  } catch (e) { console.warn('[Tribe] mention save error:', e.message) }
}

// Avatar helper — shows photo if available, falls back to initials
function Avatar({ name, avatarUrl, className = 'tribe-avatar' }) {
  const [imgError, setImgError] = useState(false)
  if (avatarUrl && !imgError) {
    return (
      <div className={className}>
        <img src={avatarUrl} alt={name || 'Member'} onError={() => setImgError(true)} />
      </div>
    )
  }
  return <div className={className}>{getInitials(name)}</div>
}

const PAIN_POINT_CATEGORIES = [
  { value:'general',          label:'General' },
  { value:'tech',             label:'🛠️ Tech / Platform Issue' },
  { value:'client',           label:'🤝 Client / Borrower Issue' },
  { value:'regulation',       label:'⚖️ Regulation / Compliance' },
  { value:'feature_request',  label:'💡 Feature Request' },
  { value:'other',            label:'❓ Other' },
]

// ─── FEED TAB ─────────────────────────────────────────────────────
function FeedTab({ userId, profile }) {
  const [posts,      setPosts]      = useState([])
  const [loading,    setLoading]    = useState(true)
  const [composing,  setComposing]  = useState('')
  const [posting,    setPosting]    = useState(false)
  const [openComments, setOpenComments] = useState({}) // postId -> bool
  const [comments,   setComments]   = useState({}) // postId -> [comments]
  const [commentDrafts, setCommentDrafts] = useState({}) // postId -> string
  const [members, setMembers] = useState([])             // for @mentions
  const [mentionedPosts, setMentionedPosts] = useState({}) // postId -> true (you were mentioned)

  // 💜 Light member list for the @ picker
  useEffect(() => {
    async function loadMembers() {
      try {
        const { data } = await supabase
          .from('profiles')
          .select('id, full_name')
          .eq('role', 'notary')
          .eq('is_approved', true)
          .order('full_name', { ascending: true })
        setMembers(data || [])
      } catch (e) { console.warn('[Tribe] members load error:', e.message) }
    }
    loadMembers()
  }, [])
  const mentionNames = useMemo(() => members.map(mm => mm.full_name).filter(Boolean), [members])
  const [editingComment, setEditingComment] = useState(null) // commentId being edited
  const [editDraft,      setEditDraft]      = useState('')    // edit input value
  const isAdmin = profile?.role === 'admin' // only admins can delete comments
  const [likes,      setLikes]      = useState({}) // postId -> { count, liked }
  const [commentCounts, setCommentCounts] = useState({}) // postId -> comment count
  const [birthdays,  setBirthdays]  = useState([])

  // 🔔 NEW-since-last-visit: NotaryPortal snapshots the previous "last seen" into
  // a prev key when the notary enters My Lounge. Anything newer gets a NEW pill.
  const prevSeen = useMemo(() => {
    try {
      if (!userId) return null
      // Prefer the prev-seen snapshot (stable for the whole visit, survives tab
      // switches). If it doesn't exist yet — first Lounge visit on this device —
      // fall back to last_seen, which still holds the PRE-visit timestamp at this
      // moment because NotaryPortal stamps it to "now" only AFTER this render.
      return localStorage.getItem(`lca_mylounge_prev_seen_${userId}`)
          || localStorage.getItem(`lca_mylounge_last_seen_${userId}`)
    } catch (e) { return null }
  }, [userId])
  const [newReplyPosts, setNewReplyPosts] = useState({}) // postId -> has new replies
  const firstNewRef = useRef(null)
  const scrolledRef = useRef(false)
  const isNewSince = ts => !!(prevSeen && ts && new Date(ts) > new Date(prevSeen))

  useEffect(() => { loadPosts(); loadBirthdays() }, [userId])

  // 🔔 Once the feed renders, glide to the first NEW item (one time per visit).
  useEffect(() => {
    if (loading || scrolledRef.current || !firstNewRef.current) return
    scrolledRef.current = true
    setTimeout(() => {
      try { firstNewRef.current && firstNewRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch (e) { /* ignore */ }
    }, 300)
  }, [loading, posts, newReplyPosts])

  async function loadPosts() {
    try {
      const { data } = await supabase
        .from('tribe_posts')
        .select('*, author:profiles!tribe_posts_author_id_fkey(id, full_name, avatar_url, headshot_url, notaries(is_vetted, is_elite))')
        .eq('is_published', true)
        .order('is_pinned', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(50)
      setPosts(data || [])

      // Load comment counts for every post (shown on the Comment button)
      if (data && data.length > 0) {
        const ids = data.map(p => p.id)
        const { data: cRows } = await supabase
          .from('tribe_post_comments')
          .select('post_id')
          .in('post_id', ids)
        const cCounts = {}
        ;(cRows || []).forEach(r => { cCounts[r.post_id] = (cCounts[r.post_id] || 0) + 1 })
        setCommentCounts(cCounts)

        // 🔔 Which posts got new replies since the last visit? Auto-open those.
        if (prevSeen && userId) {
          const { data: freshRows } = await supabase
            .from('tribe_post_comments')
            .select('post_id, author_id')
            .in('post_id', ids)
            .gt('created_at', prevSeen)
          const freshMap = {}
          ;(freshRows || []).forEach(c => { if (c.author_id !== userId) freshMap[c.post_id] = true })
          setNewReplyPosts(freshMap)
          const openIds = Object.keys(freshMap)
          if (openIds.length) {
            setOpenComments(prev => { const next = { ...prev }; openIds.forEach(id => { next[id] = true }); return next })
            openIds.forEach(id => loadComments(id))
          }
          // 💜 Were YOU mentioned since your last visit?
          try {
            const { data: mrows } = await supabase
              .from('tribe_mentions')
              .select('post_id')
              .eq('mentioned_user_id', userId)
              .gt('created_at', prevSeen)
            const mmap = {}
            ;(mrows || []).forEach(r => { if (r.post_id) mmap[r.post_id] = true })
            setMentionedPosts(mmap)
          } catch (e) { /* mentions table may not exist yet */ }
        }
      }

      // Load like counts + user likes
      if (data && data.length > 0 && userId) {
        const postIds = data.map(p => p.id)
        const { data: allLikes } = await supabase
          .from('tribe_post_likes')
          .select('post_id, user_id')
          .in('post_id', postIds)

        const likeMap = {}
        postIds.forEach(id => { likeMap[id] = { count:0, liked:false } })
        ;(allLikes || []).forEach(l => {
          if (!likeMap[l.post_id]) likeMap[l.post_id] = { count:0, liked:false }
          likeMap[l.post_id].count++
          if (l.user_id === userId) likeMap[l.post_id].liked = true
        })
        setLikes(likeMap)
      }
    } catch (err) {
      console.warn('[Tribe] Feed load error:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function loadBirthdays() {
    try {
      const today = new Date()
      const todayMMDD = `${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
      const { data } = await supabase
        .from('notaries')
        .select('birthday, id, profiles!inner(full_name)')
        .eq('birthday', todayMMDD)
      setBirthdays(data || [])
    } catch (err) {
      console.warn('[Tribe] Birthday load error:', err.message)
    }
  }

  async function publishPost() {
    if (!composing.trim() || !userId) return
    setPosting(true)
    try {
      const { data: newPost, error } = await supabase.from('tribe_posts').insert({
        author_id: userId,
        content: composing.trim(),
        is_ceo_post: false,
        is_pinned: false,
      }).select('id').single()
      if (error) throw error
      await saveMentions({ postId: newPost?.id || null, text: composing, members, authorId: userId })
      toast.success('🎉 Posted to the tribe!!')
      setComposing('')
      loadPosts()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setPosting(false)
    }
  }

  async function toggleLike(postId) {
    if (!userId) return
    const current = likes[postId] || { count:0, liked:false }
    // Optimistic update
    setLikes(prev => ({ ...prev, [postId]: { count: current.count + (current.liked ? -1 : 1), liked: !current.liked } }))
    try {
      if (current.liked) {
        await supabase.from('tribe_post_likes').delete().eq('post_id', postId).eq('user_id', userId)
      } else {
        await supabase.from('tribe_post_likes').insert({ post_id: postId, user_id: userId })
      }
    } catch (err) {
      // Revert on error
      setLikes(prev => ({ ...prev, [postId]: current }))
    }
  }

  const loadComments = useCallback(async (postId) => {
    try {
      const { data } = await supabase
        .from('tribe_post_comments')
        .select('*, author:profiles!tribe_post_comments_author_id_fkey(full_name, avatar_url, headshot_url, role)')
        .eq('post_id', postId)
        .order('created_at', { ascending: true })
      setComments(prev => ({ ...prev, [postId]: data || [] }))
      setCommentCounts(prev => ({ ...prev, [postId]: (data || []).length }))
    } catch (err) {
      console.warn('[Tribe] Comments load error:', err.message)
    }
  }, [])

  async function toggleComments(postId) {
    const isOpen = openComments[postId]
    setOpenComments(prev => ({ ...prev, [postId]: !isOpen }))
    if (!isOpen && !comments[postId]) {
      loadComments(postId)
    }
  }

  async function addComment(postId) {
    const text = (commentDrafts[postId] || '').trim()
    if (!text || !userId) return
    try {
      const { data: newComment, error } = await supabase.from('tribe_post_comments').insert({
        post_id: postId,
        author_id: userId,
        content: text,
      }).select('id').single()
      if (error) throw error
      await saveMentions({ postId, commentId: newComment?.id || null, text, members, authorId: userId })
      setCommentDrafts(prev => ({ ...prev, [postId]: '' }))
      loadComments(postId)
    } catch (err) {
      toast.error(err.message)
    }
  }

  // ✏️ Everyone can edit their OWN comment
  function startEditComment(c) {
    setEditingComment(c.id)
    setEditDraft(c.content || '')
  }
  function cancelEditComment() {
    setEditingComment(null)
    setEditDraft('')
  }
  async function saveEditComment(postId, commentId) {
    const text = editDraft.trim()
    if (!text) return
    try {
      const { error } = await supabase.from('tribe_post_comments')
        .update({ content: text })
        .eq('id', commentId)
      if (error) throw error
      setEditingComment(null)
      setEditDraft('')
      loadComments(postId)
    } catch (err) {
      toast.error(err.message)
    }
  }

  // 🗑️ Only an admin can delete a comment (any author's)
  async function deleteComment(postId, commentId) {
    if (!window.confirm('Delete this comment? This cannot be undone.')) return
    try {
      const { error } = await supabase.from('tribe_post_comments')
        .delete()
        .eq('id', commentId)
      if (error) throw error
      loadComments(postId)
      toast.success('Comment deleted')
    } catch (err) {
      toast.error(err.message)
    }
  }

  if (loading) return <div className="tribe-loading">Loading the tribe feed... 💜</div>

  return (
    <>
      {/* BIRTHDAY BANNER */}
      {birthdays.length > 0 && (
        <div className="tribe-bday-banner">
          <span className="tribe-bday-icon">🎂</span>
          <div className="tribe-bday-text">
            <div className="tribe-bday-title">Today's Birthday{birthdays.length > 1 ? 's' : ''}!!</div>
            <div className="tribe-bday-names">{birthdays.map(b => b.profiles?.full_name).filter(Boolean).join(' · ')} — wish them well!! 💚</div>
          </div>
        </div>
      )}

      {/* COMPOSE */}
      <div className="tribe-section">
        <div className="tribe-section-header">
          <span className="tribe-section-title">💜 Share with the Tribe</span>
          <span style={{ fontSize:10, fontWeight:700, color:'#2D7A4F', background:'#EAF5EE', padding:'3px 10px', borderRadius:12, letterSpacing:'0.06em', border:'1px solid #BBE5C8' }}>🛡️ NO JUDGEMENT ZONE</span>
        </div>
        <div className="tribe-compose">
          <MentionInput
            as="textarea"
            className="tribe-compose-input"
            placeholder="What's on your mind, tribe member?? Share a win, ask a question, vent freely — this is a safe space!! (Type @ to mention someone!)"
            value={composing}
            onChange={setComposing}
            members={members}
          />
          <div className="tribe-compose-actions">
            <span className="tribe-compose-hint">💡 Be kind, be helpful, be YOU!!</span>
            <button className="tribe-btn-primary" onClick={publishPost} disabled={!composing.trim() || posting}>
              {posting ? 'Posting...' : '🚀 Post to Tribe'}
            </button>
          </div>
        </div>
      </div>

      {/* POSTS */}
      <div className="tribe-section">
        <div className="tribe-section-header">
          <span className="tribe-section-title">📰 Tribe Feed</span>
          <span style={{ fontSize:11, color:'#B8B5AB' }}>{posts.length} post{posts.length !== 1 ? 's' : ''}</span>
        </div>

        {Object.keys(mentionedPosts).length > 0 && (
          <div className="tribe-mention-banner">
            💜 You were mentioned in {Object.keys(mentionedPosts).length} post{Object.keys(mentionedPosts).length !== 1 ? 's' : ''} — taking you there!
          </div>
        )}

        {posts.length === 0 ? (
          <div className="tribe-empty">
            <div className="tribe-empty-icon">💜</div>
            <div className="tribe-empty-text">The feed is quiet — be the first to share!! Welcome to the LCA Tribe!!</div>
          </div>
        ) : posts.map(p => {
          const likeData = likes[p.id] || { count:0, liked:false }
          const commentList = comments[p.id] || []
          const commentCount = comments[p.id] ? comments[p.id].length : (commentCounts[p.id] || 0)
          const isOpen = openComments[p.id]
          const isFreshPost   = isNewSince(p.created_at) && p.author_id !== userId
          const hasFreshReply = !!newReplyPosts[p.id]
          const wasMentioned  = !!mentionedPosts[p.id]
          const fresh = isFreshPost || hasFreshReply || wasMentioned
          return (
            <article key={p.id} ref={el => { if (el && fresh) { if (wasMentioned && !firstNewRef.mentioned) { firstNewRef.mentioned = el; firstNewRef.current = el } else if (!firstNewRef.current) { firstNewRef.current = el } } }} className={`tribe-post${p.is_pinned ? ' pinned' : ''}${p.is_ceo_post ? ' ceo' : ''}${fresh ? ' fresh' : ''}`}>
              <div className="tribe-post-head">
                <Avatar name={p.author?.full_name || (p.is_ceo_post ? 'Nancy Phillips' : null)} avatarUrl={p.author?.headshot_url || p.author?.avatar_url || (p.is_ceo_post ? '/Nancy%20Phillips%20in%20office.png' : null)} className={`tribe-avatar${p.is_ceo_post ? ' ceo' : ''}`} />
                <div className="tribe-post-meta">
                  <div className="tribe-post-author">
                    <span>{p.author?.full_name || (p.is_ceo_post ? 'Nancy Phillips' : 'Tribe Member')}</span>
                    {p.is_ceo_post && <span className="tribe-ceo-tag">💜 Your Friendly CEO</span>}
                    {p.is_pinned && <span className="tribe-pin-tag">📌 PINNED</span>}
                    {wasMentioned && <span className="tribe-mention-tag">@ MENTIONED YOU</span>}
                    {isFreshPost && <span className="tribe-new-tag">✨ NEW</span>}
                  </div>
                  <div className="tribe-post-time">{timeAgo(p.created_at)}</div>
                </div>
              </div>
              <div className="tribe-post-body"><MentionText text={p.content} names={mentionNames} /></div>
              <div className="tribe-post-actions">
                <button className={`tribe-action-btn${likeData.liked ? ' liked' : ''}`} onClick={() => toggleLike(p.id)}>
                  {likeData.liked ? '❤️' : '🤍'} {likeData.count > 0 ? likeData.count : 'Like'}
                </button>
                <button className="tribe-action-btn" onClick={() => toggleComments(p.id)}>
                  💬 {commentCount > 0 ? `${commentCount} comment${commentCount !== 1 ? 's' : ''}` : 'Comment'}
                </button>
                {hasFreshReply && <span className="tribe-new-tag" style={{ alignSelf:'center' }}>NEW</span>}
              </div>

              {isOpen && (
                <div className="tribe-comments">
                  {commentList.map(c => {
                    const isOwn = c.author_id === userId
                    const isEditing = editingComment === c.id
                    return (
                    <div key={c.id} className="tribe-comment">
                      <Avatar name={c.author?.full_name || (c.is_ceo_comment ? 'Nancy Phillips' : null)} avatarUrl={c.author?.headshot_url || c.author?.avatar_url || (c.is_ceo_comment ? '/Nancy%20Phillips%20in%20office.png' : null)} className="tribe-comment-avatar" />
                      <div className="tribe-comment-body">
                        <div>
                          <span className="tribe-comment-author">{c.author?.full_name || (c.is_ceo_comment ? 'Nancy Phillips' : 'Member')}</span>
                          {(c.author?.role === 'admin' || c.is_ceo_comment) && <span className="tribe-ceo-tag" style={{ marginLeft:5 }}>💜 Your Friendly CEO</span>}
                          <span className="tribe-comment-time">{timeAgo(c.created_at)}</span>
                          {isNewSince(c.created_at) && c.author_id !== userId && <span className="tribe-new-tag" style={{ marginLeft:5, fontSize:8 }}>NEW</span>}
                        </div>
                        {isEditing ? (
                          <div style={{ marginTop:6 }}>
                            <input
                              className="tribe-comment-input"
                              value={editDraft}
                              onChange={e => setEditDraft(e.target.value)}
                              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); saveEditComment(p.id, c.id) } }}
                              autoFocus
                            />
                            <div style={{ display:'flex', gap:8, marginTop:6 }}>
                              <button className="tribe-btn-outline" onClick={() => saveEditComment(p.id, c.id)}>Save</button>
                              <button className="tribe-btn-outline" onClick={cancelEditComment}>Cancel</button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="tribe-comment-text"><MentionText text={c.content} names={mentionNames} /></div>
                            {(isOwn || isAdmin) && (
                              <div style={{ display:'flex', gap:14, marginTop:4 }}>
                                {isOwn && (
                                  <button
                                    onClick={() => startEditComment(c)}
                                    style={{ background:'none', border:'none', padding:0, cursor:'pointer', fontSize:10, color:'#7A7870', fontWeight:600 }}>
                                    ✏️ Edit
                                  </button>
                                )}
                                {isAdmin && (
                                  <button
                                    onClick={() => deleteComment(p.id, c.id)}
                                    style={{ background:'none', border:'none', padding:0, cursor:'pointer', fontSize:10, color:'#E24B4A', fontWeight:600 }}>
                                    🗑️ Delete
                                  </button>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    )
                  })}
                  <div className="tribe-comment-input-wrap">
                    <MentionInput
                      as="input"
                      className="tribe-comment-input"
                      placeholder="Write a comment... (@ to mention)"
                      value={commentDrafts[p.id] || ''}
                      onChange={val => setCommentDrafts(prev => ({ ...prev, [p.id]: val }))}
                      members={members}
                      onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); addComment(p.id) } }}
                    />
                    <button className="tribe-btn-outline" onClick={() => addComment(p.id)}>Reply</button>
                  </div>
                </div>
              )}
            </article>
          )
        })}
      </div>
    </>
  )
}

// ─── DIRECTORY TAB ────────────────────────────────────────────────
function DirectoryTab() {
  const [notaries, setNotaries] = useState([])
  const [loading,  setLoading]  = useState(true)
  const [search,   setSearch]   = useState('')
  const [filter,   setFilter]   = useState('all')

  useEffect(() => {
    async function load() {
      try {
        const { data } = await supabase
          .from('profiles')
          .select('id, full_name, avatar_url, notaries(commission_state, is_vetted, is_elite, total_signings, rank)')
          .eq('role', 'notary')
          .eq('is_approved', true)
          .order('full_name', { ascending: true })
        setNotaries(data || [])
      } catch (err) {
        console.warn('[Tribe] Directory load error:', err.message)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const filtered = notaries.filter(n => {
    const matchSearch = !search ||
      n.full_name?.toLowerCase().includes(search.toLowerCase()) ||
      n.notaries?.commission_state?.toLowerCase().includes(search.toLowerCase())
    if (!matchSearch) return false
    if (filter === 'vetted') return n.notaries?.is_vetted
    if (filter === 'elite')  return n.notaries?.is_elite
    return true
  })

  const vettedCount = notaries.filter(n => n.notaries?.is_vetted).length
  const eliteCount  = notaries.filter(n => n.notaries?.is_elite).length

  if (loading) return <div className="tribe-loading">Loading tribe members... 💜</div>

  return (
    <div className="tribe-section">
      <div className="tribe-section-header">
        <span className="tribe-section-title">👥 The Tribe Directory</span>
        <span style={{ fontSize:11, color:'#B8B5AB' }}>{notaries.length} member{notaries.length !== 1 ? 's' : ''}</span>
      </div>
      <div style={{ padding:'16px 20px 0' }}>
        <input className="tribe-dir-search" placeholder="Search by name or state..." value={search} onChange={e => setSearch(e.target.value)} />
        <div className="tribe-dir-filters">
          <button className={`tribe-dir-filter${filter==='all'?' active':''}`} onClick={() => setFilter('all')}>All ({notaries.length})</button>
          <button className={`tribe-dir-filter${filter==='vetted'?' active':''}`} onClick={() => setFilter('vetted')}>🛡️ Vetted ({vettedCount})</button>
          <button className={`tribe-dir-filter${filter==='elite'?' active':''}`} onClick={() => setFilter('elite')}>⭐ Elite ({eliteCount})</button>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="tribe-empty">
          <div className="tribe-empty-icon">👥</div>
          <div className="tribe-empty-text">No tribe members match your search.</div>
        </div>
      ) : (
        <div className="tribe-dir-grid">
          {filtered.map(n => (
            <div key={n.id} className="tribe-dir-card">
              <Avatar name={n.full_name} avatarUrl={n.avatar_url} className="tribe-dir-avatar" />
              <div className="tribe-dir-name">{n.full_name || 'Tribe Member'}</div>
              <div className="tribe-dir-state">{n.notaries?.commission_state || '—'} · {n.notaries?.total_signings || 0} signings</div>
              <div className="tribe-dir-badges">
                {n.notaries?.is_vetted && <span className="tribe-dir-badge vetted">VETTED</span>}
                {n.notaries?.is_elite  && <span className="tribe-dir-badge elite">ELITE</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ─── COMING SOON TAB ──────────────────────────────────────────────
function ComingSoonTab({ userId }) {
  const [features, setFeatures] = useState([])
  const [votes,    setVotes]    = useState({}) // feature_id -> { count, voted }
  const [loading,  setLoading]  = useState(true)

  useEffect(() => { load() }, []) // eslint-disable-line

  async function load() {
    try {
      const { data: feats } = await supabase
        .from('tribe_feature_requests')
        .select('*')
        .eq('published', true)
        .order('sort_order', { ascending: true })
      setFeatures(feats || [])

      if (feats && feats.length > 0) {
        const ids = feats.map(f => f.id)
        const { data: allVotes } = await supabase
          .from('tribe_feature_votes')
          .select('feature_id, user_id')
          .in('feature_id', ids)
        const voteMap = {}
        ids.forEach(id => { voteMap[id] = { count:0, voted:false } })
        ;(allVotes || []).forEach(v => {
          if (!voteMap[v.feature_id]) voteMap[v.feature_id] = { count:0, voted:false }
          voteMap[v.feature_id].count++
          if (v.user_id === userId) voteMap[v.feature_id].voted = true
        })
        setVotes(voteMap)
      }
    } catch (err) {
      console.warn('[Tribe] ComingSoon load error:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function toggleVote(featureId) {
    if (!userId) return
    const current = votes[featureId] || { count:0, voted:false }
    setVotes(prev => ({ ...prev, [featureId]: { count: current.count + (current.voted ? -1 : 1), voted: !current.voted } }))
    try {
      if (current.voted) {
        await supabase.from('tribe_feature_votes').delete().eq('feature_id', featureId).eq('user_id', userId)
      } else {
        await supabase.from('tribe_feature_votes').insert({ feature_id: featureId, user_id: userId })
        toast.success('🗳️ Vote counted!! The tribe is listening!!')
      }
    } catch (err) {
      setVotes(prev => ({ ...prev, [featureId]: current }))
    }
  }

  if (loading) return <div className="tribe-loading">Loading sneak previews... 💜</div>

  return (
    <div className="tribe-section">
      <div className="tribe-cs-intro">
        <div className="tribe-cs-intro-title">🚪 The Coming Soon Lounge</div>
        <div className="tribe-cs-intro-text">Here's what's brewing for the LCA Tribe!! Vote for what you want most — your votes shape what we build next!! 💜</div>
      </div>

      {features.length === 0 ? (
        <div className="tribe-empty">
          <div className="tribe-empty-icon">🚪</div>
          <div className="tribe-empty-text">No previews yet — check back soon!!</div>
        </div>
      ) : (
        <div className="tribe-cs-grid">
          {features.map(f => {
            const v = votes[f.id] || { count:0, voted:false }
            return (
              <div key={f.id} className="tribe-cs-card">
                <div className="tribe-cs-icon">{f.icon || '⭐'}</div>
                <div className="tribe-cs-title">{f.title}</div>
                <div className="tribe-cs-desc">{f.description || ''}</div>
                <div className="tribe-cs-actions">
                  <span className={`tribe-cs-status ${f.status}`}>
                    {f.status === 'planned'      && '👀 PLANNED'}
                    {f.status === 'researching'  && '🔬 RESEARCHING'}
                    {f.status === 'building'     && '🚧 BUILDING'}
                    {f.status === 'shipped'      && '✅ SHIPPED'}
                  </span>
                  <button
                    className={`tribe-cs-vote${v.voted ? ' voted' : ''}`}
                    onClick={() => toggleVote(f.id)}
                    disabled={f.status === 'shipped'}
                  >
                    {v.voted ? '✓' : '🗳️'} {v.count}
                  </button>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

// ─── PAIN POINT TAB ───────────────────────────────────────────────
function PainPointTab({ userId, profile }) {
  const [form, setForm] = useState({
    category: 'general',
    pain_point: '',
    ideal_fix: '',
    is_anonymous: false,
  })
  const [submitting, setSubmitting] = useState(false)
  const [submitted,  setSubmitted]  = useState(false)

  async function submit() {
    if (!form.pain_point.trim()) {
      toast.error('Please describe the pain point!!')
      return
    }
    setSubmitting(true)
    try {
      const { error } = await supabase.from('tribe_pain_points').insert({
        author_id: form.is_anonymous ? null : userId,
        author_name: form.is_anonymous ? null : (profile?.full_name || null),
        category: form.category,
        pain_point: form.pain_point.trim(),
        ideal_fix: form.ideal_fix.trim() || null,
        is_anonymous: form.is_anonymous,
        status: 'new',
      })
      if (error) throw error
      setSubmitted(true)
      setForm({ category: 'general', pain_point: '', ideal_fix: '', is_anonymous: false })
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSubmitting(false)
    }
  }

  if (submitted) {
    return (
      <div className="tribe-section">
        <div className="tribe-pp-success">
          <div className="tribe-pp-success-icon">💚</div>
          <div className="tribe-pp-success-title">Thank you, tribe member!!</div>
          <div className="tribe-pp-success-text">
            Your voice has been heard. Nancy Phillips, Your Friendly CEO, reads EVERY submission personally and turns pain points into solutions.<br /><br />
            When something gets built because of you, we'll celebrate together!! 🎉
          </div>
          <button className="tribe-btn-primary" style={{ marginTop:16 }} onClick={() => setSubmitted(false)}>
            ➕ Submit Another
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="tribe-section">
      <div className="tribe-pp-intro">
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6, flexWrap:'wrap' }}>
          <div className="tribe-pp-intro-title" style={{ marginBottom:0 }}>🆘 What's frustrating you??</div>
          <span style={{ fontSize:10, fontWeight:700, color:'#2D7A4F', background:'#EAF5EE', padding:'3px 10px', borderRadius:12, letterSpacing:'0.06em', border:'1px solid #BBE5C8' }}>🛡️ NO JUDGEMENT ZONE</span>
        </div>
        <div className="tribe-pp-intro-text">
          Every pain point you share becomes a premium opportunity to make the LCA Tribe better!! Nancy Phillips, Your Friendly CEO, reads each one personally — your voice shapes what we build next!! 💜
        </div>
      </div>

      <div className="tribe-pp-form">
        <label className="tribe-pp-label">CATEGORY</label>
        <select className="tribe-pp-select" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}>
          {PAIN_POINT_CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>

        <label className="tribe-pp-label">WHAT'S THE PAIN POINT?? *</label>
        <textarea
          className="tribe-pp-textarea"
          placeholder="Describe what's frustrating you... be honest, vent freely!! Nothing's too small!!"
          value={form.pain_point}
          onChange={e => setForm(f => ({ ...f, pain_point: e.target.value }))}
        />

        <label className="tribe-pp-label">WHAT WOULD THE IDEAL FIX LOOK LIKE?? (Optional)</label>
        <textarea
          className="tribe-pp-textarea"
          placeholder="If you could wave a magic wand... what would solve this for you??"
          value={form.ideal_fix}
          onChange={e => setForm(f => ({ ...f, ideal_fix: e.target.value }))}
        />

        <label className="tribe-pp-check">
          <input
            type="checkbox"
            checked={form.is_anonymous}
            onChange={e => setForm(f => ({ ...f, is_anonymous: e.target.checked }))}
            style={{ width:'auto', cursor:'pointer' }}
          />
          <span>🤫 Submit anonymously (Your Friendly CEO will see the issue but not your name)</span>
        </label>

        <div style={{ marginTop:20, display:'flex', justifyContent:'flex-end' }}>
          <button className="tribe-btn-primary" onClick={submit} disabled={submitting || !form.pain_point.trim()}>
            {submitting ? 'Sending...' : '💜 Send to Your Friendly CEO'}
          </button>
        </div>
      </div>
    </div>
  )
}

// ─── MAIN ─────────────────────────────────────────────────────────
export default function Tribe() {
  const [tab,     setTab]     = useState('feed')
  const [userId,  setUserId]  = useState(null)
  const [profile, setProfile] = useState(null)

  useEffect(() => {
    async function init() {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) return
      setUserId(user.id)
      const { data: prof } = await supabase.from('profiles').select('full_name, role').eq('id', user.id).single()
      setProfile(prof)
    }
    init()
  }, [])

  return (
    <>
      <style>{TRIBE_STYLES}</style>
      <div className="tribe-hero">
        <div className="tribe-hero-badge">✨ PHASE 1 — THE SPARK</div>
        <h1 className="tribe-hero-title">💜 The Notary Lounge</h1>
        <p className="tribe-hero-sub">Your professional home — where notary excellence is celebrated, wisdom is shared, and Your Friendly CEO listens to every voice!! Welcome home, tribe member!!</p>
      </div>

      <div className="tribe-tabs">
        <button className={`tribe-tab${tab==='feed'?' active':''}`} onClick={() => setTab('feed')}>📰 Feed</button>
        <button className={`tribe-tab${tab==='directory'?' active':''}`} onClick={() => setTab('directory')}>👥 Directory</button>
        <button className={`tribe-tab${tab==='coming-soon'?' active':''}`} onClick={() => setTab('coming-soon')}>🚪 Coming Soon</button>
        <button className={`tribe-tab${tab==='pain-point'?' active':''}`} onClick={() => setTab('pain-point')}>🆘 Pain Point</button>
      </div>

      {tab === 'feed'        && <FeedTab        userId={userId} profile={profile} />}
      {tab === 'directory'   && <DirectoryTab   />}
      {tab === 'coming-soon' && <ComingSoonTab  userId={userId} />}
      {tab === 'pain-point'  && <PainPointTab   userId={userId} profile={profile} />}
    </>
  )
}
